import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { debounceTime, first, map, take, tap } from 'rxjs/operators';

import { HandleErrorService } from '../../interceptors/handle-error.service';
import { SharedServiceService } from '../../services/shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class AntiAuthGuard implements CanActivate, CanLoad {

  constructor(
    private readonly handleErrorS: HandleErrorService,
    private sharedS: SharedServiceService,
    private router: Router
  ) { }

  /**
   * Valida que el usuario NO esté autenticado
   * Si está autenticado, redirige a main
   */
  private validateNonAuthUser = (): Observable<boolean> =>
    combineLatest([
      this.isJwtLocal(),
      this.sharedS.isUrlWithTokenWA$
    ])
      .pipe(first(), map(resp => !(resp[0] || resp[1])));

  private isJwtLocal = (): Observable<boolean> =>
    this.handleErrorS.getToken$()
      .pipe(
        debounceTime(500),
        map(jwt => jwt ? true : false),
      )

  canLoad(): Observable<boolean> {
    return this.validateNonAuthUser()
      .pipe(
        tap(estado => {
          if (!estado) {
            // Usuario está autenticado, redirigir a main
            this.router.navigate(['/main']);
            this.sharedS.loadingBottleDismiss();
          }
        }),
        take(1)
      );
  }

  canActivate(): Observable<boolean> {
    return this.validateNonAuthUser()
      .pipe(
        tap(estado => {
          if (!estado) {
            // Usuario está autenticado, redirigir a main
            this.router.navigate(['/main']);
            this.sharedS.loadingBottleDismiss();
          }
        })
      );
  }
}
